import { Dialog, DialogPanel } from "@headlessui/react";

import { CSSProperties, JSX, ReactNode } from "react";

import { cn } from "@/utils/cn.ts";

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  children: ReactNode;
  className?: string;
  onBack?: () => void;
  style?: CSSProperties | undefined;
}

const Modal = ({ isOpen, closeModal, children, className, style }: ModalProps): JSX.Element => {
  return (
    <Dialog
      open={isOpen}
      transition
      onClose={closeModal}
      className={
        "fixed inset-0 z-50 flex w-screen items-center justify-center overflow-y-auto bg-[#141414CC] px-4 backdrop-blur-sm transition data-[closed]:scale-95 data-[closed]:opacity-0"
      }
    >
      <DialogPanel className={cn("staff-modal  h-max w-full", className)} style={style}>
        {children}
      </DialogPanel>
    </Dialog>
  );
};

export default Modal;
